/* ============================================================
   MANOLEA — interactions
   Slow & subtle only (DESIGN.md §7): fade-and-rise, brushstroke
   paint-in once, sticky mobile Add-to-Cart visibility.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal: fade + 16px rise, once ----------------
     A plain rAF-throttled scroll sweep — more reliable than an
     IntersectionObserver on programmatic jumps / anchor loads.
     Reveals anything whose top crosses 92% of the viewport, and on
     init reveals everything already in or above view (covers a page
     that loads already scrolled). No element is ever left invisible. */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.ml-reveal:not(.is-in)'));
    if (!els.length) return;
    if (reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }

    function sweep() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = els.length - 1; i >= 0; i--) {
        if (els[i].getBoundingClientRect().top < vh * 0.92) {
          els[i].classList.add('is-in');
          els.splice(i, 1);
        }
      }
      if (!els.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sweep(); ticking = false; });
    }
    sweep();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---- Brushstroke paint-in: runs ONCE on load -------------- */
  function initBrush() {
    document.querySelectorAll('.ml-brush[data-paint]').forEach(function (svg) {
      if (reduce) return;
      // re-trigger reliably after fonts/layout settle
      requestAnimationFrame(function () { svg.classList.add('ml-brush--animate'); });
    });
  }

  /* ---- Sticky mobile Add-to-Cart: show after hero ATC scrolls off
     The bar lives in the PDP section; we toggle .is-visible. -- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-ml-sticky-atc]');
    var anchor = document.querySelector('[data-ml-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // when the in-page Add-to-Cart is NOT visible, show the sticky bar
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---- Scroll progress: thin gold bar at the top ------------ */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'ml-scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (h.scrollTop || window.pageYOffset) / max : 0;
      bar.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---- Split the hero headline into words, reveal in sequence */
  function initSplitHeadline() {
    if (reduce) return;
    var h = document.querySelector('.ml-hero__text .ml-headline');
    if (!h || h.dataset.mlSplit) return;
    h.dataset.mlSplit = '1';
    var words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'ml-word';
      var inner = document.createElement('span');
      inner.className = 'ml-word__in';
      inner.textContent = w;
      inner.style.transitionDelay = (0.35 + i * 0.06) + 's';
      span.appendChild(inner);
      h.appendChild(span);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
    requestAnimationFrame(function () { h.classList.add('ml-split-in'); });
  }

  /* ---- Magnetic primary buttons (pointer devices only) ------ */
  function initMagnetic() {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.ml-btn--solid').forEach(function (btn) {
      var strength = 0.28;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * strength;
        var y = (e.clientY - r.top - r.height / 2) * strength;
        btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---- Gentle parallax on section images -------------------- */
  function initParallax() {
    if (reduce) return;
    var els = [].slice.call(document.querySelectorAll('[data-ml-parallax] img, img[data-ml-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh; // -0.5..0.5-ish
        var shift = (progress * -34).toFixed(1); // px
        img.style.transform = 'scale(1.14) translate3d(0,' + shift + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    window.__mlReady = true;
    initReveal(); initBrush(); initStickyAtc();
    try { initScrollProgress(); initSplitHeadline(); initMagnetic(); initParallax(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init reveal when sections are added/edited in the theme editor
  document.addEventListener('shopify:section:load', initReveal);
})();
